import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from 'lodash';

import Aqp from '../../../libs/mk-react-aqp';

import {fetchUserFriends, resetUserFriends} from "../../../creators/user.friends";
import {deleteUserFriend, updateUserFriend} from "../../../creators/user.friend";
import {fetchUserFriendsRequest, resetUserFriendsRequest,} from "../../../creators/user.friendsRequest";
import {deleteUserFriendRequest, updateUserFriendRequest} from "../../../creators/user.friendRequest";
import {fetchUserFriendsSidebar, resetUserFriendsSidebar} from "../../../creators/user.friends.sidebar";


import Friends from './components/Friend';
import {LoadingBar, PageLoader} from '../Loader';
import AvatarFriend from "./components/AvatarFriend";
import ManageFriend from "./components/ManageFriend";
import FriendRequest from "./components/FriendRequest";
import Pagination from "../Pagination";
import AddFriendToChat from "./components/AddFriendToChat";

class FriendsList extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 50,
            page: 1,
            search: ""
        };
        this.aqp = new Aqp({search: "utilisateur"}, {
            blacklist: ['limit', 'page'],
            currentLink: this.props.currentUrl,
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: (this.props.match && this.props.match.params && this.props.match.params.page) || 1},
        };
        this.handleSearchFriend = this.handleSearchFriend.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.getUserFriends = _.debounce(this.getUserFriends, 300);

        this.getUserFriends({
            ...this.state.filter,
            limit: this.props.limit !== undefined ? this.props.limit : this.state.filter.limit
        });
        this.props.fetchUserFriendsRequest(this.props.user._id, {status: 0, limit : false, sort : "-createdAt"});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userFriends !== this.props.userFriends) {
            this.setState({list: this.props.userFriends});
        }
        if (_.get(prevProps,"user._id") !== _.get(this.props,"user._id")) {
            this.props.fetchUserFriendsRequest(this.props.user._id, {status: 0, limit : false, sort : "-createdAt"});
        }
    }

    componentWillUnmount() {
        this.props.resetUserFriends();
        this.props.resetUserFriendsRequest();
        this.setState({search: ""});
    }

    handleRemoveFriend(friendId) {
        this.props.deleteUserFriend(this.props.user._id, friendId);
        let filter = {...this.state.filter, search: "", page: 1};
        this.setState({filter});
        this.getUserFriends({filter});
    }


    handleSearchFriend(event) {
        let filter = {...this.state.filter, search: event.target.value, page: 1};
        this.setState({filter});
        this.getUserFriends(filter);
    }

    handleAcceptFriendRequest(answerId) {
        this.props.updateUserFriendRequest(this.props.user._id, answerId);
    }

    handleRefuseFriendRequest(answerId){
        this.props.deleteUserFriendRequest(this.props.user._id, answerId);
    }

    getUserFriends(filter) {
        filter = {...filter};
        if(_.get(this.props,"user._id")){
            this.props.fetchUserFriends(this.props.user._id, this.aqp.set(filter));
        }
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getUserFriends(filter);
        window.scrollTo(0, 0);
    }


    render() {
        let totalPage = Math.ceil(this.props.userFriendsTotal / this.state.filter.limit);
        return (
            <div className="friends-wrapper">
                {this.props.isMe && this.props.type === "profileFriends" && (
                    !this.props.userFriendsRequestInitialized ? (
                        <PageLoader />
                    ) : (
                        <div className={"friends-requests"}>
                            <div className={"head-title display-6"}>
                                {this.props.userFriendsRequestTotal} Demande{this.props.userFriendsRequestTotal > 1 ? "s" : ""} d'amitié{this.props.userFriendsRequestTotal > 1 ? "s" : ""}
                            </div>
                            {this.props.userFriendsRequestTotal >= 1 && this.props.userFriendsRequest.map((item) => (
                                <FriendRequest key={item._id}
                                               {...item}
                                               handleAcceptFriendRequest={this.handleAcceptFriendRequest.bind(this)}
                                               handleRefuseFriendRequest={this.handleRefuseFriendRequest.bind(this)}
                                               userFriendsRequestInitialized={this.props.userFriendsRequestInitialized}/>
                            ))}
                        </div>
                    )
                )}

                {this.props.userFriendsInitialized && (
                    <Fragment>
                        {this.props.displayTitle && (
                            <div className="topline">
                                <div className={"head-title display-5"}>
                                    {`${this.props.isMe ? 'Mes' : 'Ses'} ${this.props.userFriendsTotal} ami(e)${this.props.userFriendsTotal > 1 ? "s" : ""}`}
                                </div>
                                {this.props.displayFriendsSearch && (
                                    <Fragment>
                                        <div className="searchbar">
                                            <input type="text" value={this.state.filter.search}
                                                   onChange={(event) => this.handleSearchFriend(event)}
                                                   placeholder="Rechercher un(e) ami(e)"/>
                                        </div>
                                        {this.props.userFriendsLoading && (
                                            <LoadingBar />
                                        )}
                                    </Fragment>
                                )}
                            </div>
                        )}

                        {this.props.userFriendsTotal === 0 && (
                            <div className={"no-content"}>Aucun ami</div>
                        )}
                        <div className={"list"}>
                            {this.props.userFriends.map((item) => {
                                if (this.props.type === "profilDescription") {
                                    return <AvatarFriend {...item}
                                                         key={item._id}
                                                         userFriendsInitialized={this.props.userFriendsInitialized}/>
                                } else if (this.props.type === "profileFriends") {
                                    return <ManageFriend {...item}
                                                         key={item._id}
                                                         isMe={this.props.isMe}
                                                         userId={this.props.userId}
                                                         isFavourite={item.favourite}
                                                         handleRemoveFriend={this.handleRemoveFriend.bind(this)}
                                                         userFriendsInitialized={this.props.userFriendsInitialized}/>
                                } else if (this.props.type === "chatAddUser") {
                                    return <AddFriendToChat {...item}
                                                            key={item._id}
                                                            isMe={this.props.isMe}
                                                            handleAddUser={this.props.handleAddUser}
                                                            usersIds={this.props.usersIds}
                                                            userId={this.props.userId}
                                                            userFriendsLoading={this.props.userFriendsLoading}
                                                            userFriendsInitialized={this.props.userFriendsInitialized}/>
                                } else {
                                    return <Friends key={item._id}
                                                    {...item}
                                                    {...this.props}
                                                    userId={this.props.userId}
                                                    isFavourite={item.favourite}
                                                    userFriendsInitialized={this.props.userFriendsInitialized}
                                                    index={item._id}/>
                                }
                            })}
                        </div>
                        {this.props.type === "profileFriends" && totalPage > 1 && (
                            <Pagination
                                currentPage={this.state.filter.page}
                                pagesCount={totalPage}
                                handleChangePage={this.handleChangePage}
                                {...this.aqp.queryUrl(this.state.filter)}
                            />
                        )}
                    </Fragment>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFriends: state.userFriends.data,
        userFriendsLoading: state.userFriends.loading,
        userFriendsInitialized: state.userFriends.initialized,
        userFriendsTotal: state.userFriends.total,

        userFriendsSidebar: state.userFriendsSidebar.data,
        userFriendsSidebarInitialized: state.userFriendsSidebar,

        userFriendsRequest: state.userFriendsRequest.data,
        userFriendsRequestLoading: state.userFriendsRequest.loading,
        userFriendsRequestInitialized: state.userFriendsRequest.initialized,
        userFriendsRequestTotal: state.userFriendsRequest.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFriends,
    resetUserFriends,

    fetchUserFriendsSidebar,
    resetUserFriendsSidebar,

    fetchUserFriendsRequest,
    resetUserFriendsRequest,

    updateUserFriendRequest,
    deleteUserFriendRequest,

    updateUserFriend,
    deleteUserFriend,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(FriendsList);
